module.exports = __webpack_public_path__ + "img/logo_facebook.a937dc2a.svg";